"use client";

import React, { createContext, useContext } from "react";

export type FloatingBoundaryPadding =
  | number
  | {
      top?: number;
      right?: number;
      bottom?: number;
      left?: number;
    };

export type FloatingBoundaryValue = {
  /**
   * The element that floating overlays should treat as their collision boundary.
   * When null, consumers fall back to viewport collision detection.
   */
  element: Element | null;
  /**
   * Insets for detectOverflow (e.g. sticky column strip on the left).
   */
  padding?: FloatingBoundaryPadding;
};

const defaultValue: FloatingBoundaryValue = { element: null };

const Context = createContext<FloatingBoundaryValue>(defaultValue);

type IProps = {
  value: FloatingBoundaryValue;
  children: React.ReactNode;
};

export const FloatingBoundaryProvider: React.FC<IProps> = ({
  value,
  children,
}) => {
  return <Context value={value}>{children}</Context>;
};

/**
 * Returns the nearest floating collision boundary configuration.
 */
export const useFloatingBoundary = (): FloatingBoundaryValue => {
  return useContext(Context);
};
